/**
 * DepartmentAssignment.jsx — Departman Mesai Planı Atama Paneli
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Save, Loader2 } from 'lucide-react';

const DepartmentAssignment = ({
  departments = [],
  schedules = [],
  assignments = {},
  saving,
  onAssignmentChange,
  onSave,
}) => {
  const { t } = useTranslation();

  if (!departments.length) {
    return (
      <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
        <p className="text-sm text-slate-400">{t('dept_assign_empty', 'Departman bulunamadı.')}</p>
      </div>
    );
  }

  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex items-center justify-between mb-5">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-cyan-600">
            {t('dept_assign_kicker', 'Departman Atamaları')}
          </p>
          <h3 className="mt-1 text-lg font-black text-slate-900">
            {t('dept_assign_title', 'Departman Bazlı Mesai Planı')}
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            {t('dept_assign_desc', 'Her departman için varsayılan mesai planını seçin.')}
          </p>
        </div>
        <button
          onClick={onSave}
          disabled={saving}
          className="flex items-center gap-1.5 rounded-xl bg-cyan-600 px-4 py-2 text-xs font-bold text-white hover:bg-cyan-700 disabled:opacity-50 transition-colors"
        >
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}
          {t('save', 'Kaydet')}
        </button>
      </div>

      <div className="space-y-2">
        {departments.map((dept) => (
          <div
            key={dept.id}
            className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-100 bg-white p-4"
          >
            <div>
              <div className="text-sm font-bold text-slate-800">{dept.name || dept.department_name}</div>
              <div className="text-[10px] font-medium text-slate-400">
                {dept.employee_count || 0} {t('dept_assign_employees', 'personel')}
              </div>
            </div>
            <select
              value={assignments[dept.id] || ''}
              onChange={(e) => onAssignmentChange(dept.id, e.target.value)}
              className="rounded-xl border border-slate-200 px-3 py-2 text-xs font-bold min-w-[180px]"
            >
              <option value="">{t('dept_assign_none', 'Atanmamış')}</option>
              {(schedules || []).map((s) => (
                <option key={s.id} value={String(s.id)}>
                  {s.name} ({s.start_time}-{s.end_time})
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DepartmentAssignment;